import { Settings } from 'lucide-react';

interface CookieBannerProps {
  onAccept: () => void;
  onRefuse: () => void;
  onCustomize: () => void;
}

export function CookieBanner({ onAccept, onRefuse, onCustomize }: CookieBannerProps) {
  return (
    <div
      role="region"
      aria-label="Gestion des cookies"
      className="fixed bottom-0 left-0 right-0 z-[9998] animate-slide-up"
    >
      <div className="mx-2 mb-2 sm:mx-4 sm:mb-4 md:mx-auto md:max-w-4xl">
        <div className="bg-white rounded-2xl shadow-2xl border border-gray-200/80 overflow-hidden">
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 px-5 py-4 sm:px-6 sm:py-5">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1.5">
                <div className="w-5 h-5 rounded bg-blue-600 flex items-center justify-center flex-shrink-0">
                  <span className="text-white text-[10px] font-bold">🍪</span>
                </div>
                <span className="text-sm font-semibold text-gray-900">Cookies</span>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">
                TrezoOne utilise des cookies nécessaires au bon fonctionnement du site et, avec votre accord, des cookies de mesure d'audience afin d'améliorer votre expérience.{' '}
                <a
                  href="/politique-confidentialite"
                  className="text-blue-600 hover:underline focus:outline-none focus:ring-1 focus:ring-blue-500 rounded"
                >
                  En savoir plus
                </a>
              </p>
            </div>

            <div className="flex flex-row sm:flex-col lg:flex-row items-center gap-2 flex-shrink-0">
              <button
                onClick={onRefuse}
                className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-gray-400 whitespace-nowrap"
              >
                Refuser
              </button>
              <button
                onClick={onCustomize}
                className="px-4 py-2 text-sm font-medium text-blue-700 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 flex items-center gap-1.5 whitespace-nowrap"
              >
                <Settings size={14} />
                Personnaliser
              </button>
              <button
                onClick={onAccept}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500 whitespace-nowrap"
              >
                Accepter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
